<template>
    <div class="card" v-animate-css="'fadeInLeft'">
        <div class="card-header">
            <h3 class="card-title">
                <span v-if="!api.id"> Add </span>
                <span v-if="api.id"> Edit </span>
                API
            </h3>
            <div class="card-tools">
                <div class="overlay" v-if="isLoading">
                    <i class="fas fa-sync-alt fa-spin fa-1x"></i>
                </div>

                <button class="btn btn-tool btn-sm" v-if="!isLoading" @click.prevent="clear()">
                    <i class="fa fa-plus"></i>
                </button>
            </div>
        </div>
        <div class="card-body">
            <form role="form">
                <div class="row">
                    <div class="col-md-8">
                        <div class="form-group">
                            <label>Name</label>
                            <input type="text" class="form-control" v-model="api.name">
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Type</label>
                            <select class="form-control" v-model="api.type">
                                <option v-for="(name, code) in types" :key="code" :value="code">{{ name }}</option>
                            </select>
                        </div>
                    </div>
                </div>

                <!-- AdManager -->
                <div class="row" v-if="api.type === 'admanager'">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Network Code</label>
                            <input type="number" class="form-control" v-model="api.networkCode">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Application Name</label>
                            <input type="text" class="form-control" v-model="api.applicationName">
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>JSON Key File Path</label>
                            <input type="text" class="form-control" v-model="api.jsonKeyFilePath">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Scopes</label>
                            <input type="text" class="form-control" v-model="api.scopes">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Impersonated Email</label>
                            <input type="email" class="form-control" v-model="api.impersonatedEmail">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Account Email</label>
                            <input type="email" class="form-control" v-model="api.accountEmail">
                        </div>
                    </div>
                </div>

                <!-- AdSense -->
                <div class="row" v-if="api.type === 'adsense'">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Account ID</label>
                            <input type="text" class="form-control" v-model="api.accountID">
                        </div>
                    </div>
                </div>

                <!-- Postquare -->
                <div class="row" v-if="api.type === 'postquare'">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Username</label>
                            <input type="text" class="form-control" v-model="api.username">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>API Token</label>
                            <input type="text" class="form-control" v-model="api.api_token">
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Scope</label>
                            <input type="text" class="form-control" v-model="api.scope">
                        </div>
                    </div>
                </div>

                <!-- Netlink -->
                <div class="row" v-if="api.type === 'netlink'">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Username</label>
                            <input type="text" class="form-control" v-model="api.username">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Password</label>
                            <input type="password" class="form-control" v-model="api.password">
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>URL</label>
                            <input type="text" class="form-control" v-model="api.url">
                        </div>
                    </div>
                </div>

                <!-- AniView -->
                <div class="row" v-if="api.type === 'aniview'">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Account ID</label>
                            <input type="text" class="form-control" v-model="api.accountID">
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Email</label>
                            <input type="email" class="form-control" v-model="api.email">
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Password</label>
                            <input type="password" class="form-control" v-model="api.password">
                        </div>
                    </div>
                </div>

                <!-- AdVergic -->
                <div class="row" v-if="api.type === 'advergic'">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>API Key</label>
                            <input type="text" class="form-control" v-model="api.api_key">
                        </div>
                    </div>
                </div>

                <!-- IncrementX -->
                <div class="row" v-if="api.type === 'incrementx'">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Username</label>
                            <input type="text" class="form-control" v-model="api.username">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Password</label>
                            <input type="password" class="form-control" v-model="api.password">
                        </div>
                    </div>
                </div>

                <!-- AdCrew Exchange -->
                <div class="row" v-if="api.type === 'adcrewexchange'">
                    <div class="col-md-8">
                        <div class="form-group">
                            <label>Exchange URL</label>
                            <input type="url" class="form-control" v-model="api.base_url" placeholder="https://exchange-admin.adcrew.co">
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Revenue</label>
                            <select class="form-control" v-model="api.revenue_basis">
                                <option value="net">Net (paid to the seller)</option>
                                <option value="gross">Gross (key needs gross access)</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Report Key</label>
                            <input type="password" class="form-control" v-model="api.api_key" autocomplete="off">
                            <small class="text-muted">From the exchange console: Govern → Report keys.</small>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group float-right">
                            <button class="btn btn-success" @click.prevent="submit()"> Save </button>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <errors :errors="errors"/>
                        <messages :messages="messages" />
                    </div>
                </div>
            </form>
        </div>
    </div>

</template>

<script>
import { RepositoryFactory } from '@/services/repositories/ManagementAPI/RepositoryFactory'
const APIRepo = RepositoryFactory.get('external_apis')

export default {
    props: {
        api: {
            required: true,
            type: Object
        },
        isLoading: {
            required: false,
            type: Boolean
        },
        selectedType: {
            required: false,
            type: String
        },
    },
    data() {
        return {
            types: {
                admanager: 'AdManager',
                adsense: 'AdSense',
                postquare: 'Postquare',
                netlink: 'Netlink',
                aniview: 'AniView',
                advergic: 'AdVergic',
                incrementx: 'IncrementX',
                adcrewexchange: 'AdCrew Exchange',
            },
            messages: [],
            errors: []
        }
    },
    methods: {
        submit: function() {
            if(typeof this.api.id === 'undefined') {
                this.create(this.api)
            } else {
                this.update(this.api)
            }
        },
        clear: function() {
            this.errors = []
            this.messages = []
            this.$emit('clear')
        },
        create: function(api) {
            this.errors = []
            this.messages = []

            const type = api.type || this.selectedType
            APIRepo.post(type, api).then(result => {
                if(typeof result.data.id !== 'undefined') {
                    this.messages.push("Successfully added with ID: " + result.data.id)
                    this.$emit('updateList', result.data)
                }
            }).catch(err => {
                this.errors.push(err)
                if (err.response && err.response.data) {
                    this.errors.push(err.response.data)
                }
            })
        },
        update: function(api) {
            this.errors = []
            this.messages = []

            const type = api.type || this.selectedType
            APIRepo.patch(type, this.api.id, api).then(result => {
                if(typeof result.data.id !== 'undefined') {
                    this.messages.push("Successfully updated.")
                    this.$emit('refreshList', true)
                }
            }).catch(err => {
                this.errors.push(err)
                if (err.response && err.response.data) {
                    this.errors.push(err.response.data)
                }
            })
        },
    },
}
</script>
